import { Text, textVariantsEnum, fontWeightEnum } from '../Text';
import styles from './EmptyState.module.scss';
export const EmptyStateComponent = ({ message, customMessageComponent }) => {
  return (
    <div className={styles.emptyStateContainer}>
      {customMessageComponent ? (
        customMessageComponent
      ) : (
        <Text
          variant={textVariantsEnum.Text_md}
          fontWeight={fontWeightEnum.Medium}
        >
          {message ? message : 'No Data Found'}
        </Text>
      )}
    </div>
  );
};
